// extracted by extract-css-chunks-webpack-plugin
module.exports = {"yaowen_center_box":"yaowen_center_box-3Kjo1o6j"};